import { effect, Injector } from '@angular/core';

export function waitFor<T>(
  injector: Injector,
  selector: () => T,
  predicate: (value: T) => boolean,
  timeoutMs = 10_000
): Promise<T> {
  return new Promise((resolve, reject) => {
    const ref = effect(
      () => {
        const value = selector();
        try {
          if (predicate(value)) {
            ref.destroy();
            resolve(value);
          }
        } catch (err) {
          ref.destroy();
          reject(err);
        }
      },
      { injector }
    );

    if (timeoutMs > 0) {
      setTimeout(() => {
        ref.destroy();
        reject(new Error(`waitFor timed out after ${timeoutMs}ms`));
      }, timeoutMs);
    }
  });
}
